import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
/**
 * An nile-badge element.
 *
 * @fires count-changed - Indicates when the count changes
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('nile-badge')
export class NileBadge extends LitElement {
  static override styles = css`
    :host {
      display: block;
    }
    .nds-badge {
      width: 24px;
      height: 24px;
      border-radius: 9rem;
      font-size: 14px;
      justify-content: space-around;
      font-weight: bold;
      display: flex;
      background-color: rgb(221, 221, 221);
      flex-wrap: nowrap;
      align-items: center;
      color: var(--nile-colors-dark-900);
    }

    .nds-badge:hover {
      background: rgba(0, 94, 166, 0.1);
    }
    
    .nds-badge__link {
      font-family: var(--nile-font-family-sans-serif);
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 1;
      letter-spacing: 0.2px;
      text-decoration: none;
      font-size: 12px;
    }

    .nds-badge__link:hover {
      color: var(--nile-colors-dark-900);
    }
    
    .nds-badge--active {
      background-color: var(--nile-colors-primary-700);
      color: var(--nile-colors-neutral-100);
    }

    .nds-badge--active:hover {
      background-color: var(---nile-colors-primary-700);
    }

    .nds-badge__icon {
      margin-bottom: 0;
      height: 14px;
    }
  `;

  /**
   * Button Lab
   */
  @property()
  name = 0;

  /**
   * Button Lab
   */
  @property()
  icon: string = '';

  /**
   * Button Lab
   */
  @property()
  active: boolean = false;

  get buttonClassMap() {
    return {
      'nds-badge--active': this.active,
    };
  }

  /**
   * Button Lab
   */
  @property()
  href = '/';

  _hasSlotContent(slotName: string) {
    const slot = this.querySelector(`slot[name=${slotName}]`);
    console.log(slot, 'slot');
  }

  override render() {
    const { name, icon, href } = this;
    const hrefPath = `/${href}`;
    return html`
      <a class="nds-badge ${classMap(this.buttonClassMap)}">
        <span class="nds-badge__link">${this.name}</span>
      </a>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nile-badge': NileBadge;
  }
}

// <span class="nds-badge__icon">
// <nile-icon name="${this.icon}" size="14" color="#000"></nile-icon>
// </span>
